import { render, staticRenderFns } from "./r-smart-offer-bundle-reward-giver.vue?vue&type=template&id=d8cd8c0a"
import script from "./r-smart-offer-bundle-reward-giver.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-reward-giver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8cd8c0a')) {
      api.createRecord('d8cd8c0a', component.options)
    } else {
      api.reload('d8cd8c0a', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-reward-giver.vue?vue&type=template&id=d8cd8c0a", function () {
      api.rerender('d8cd8c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-reward-giver/r-smart-offer-bundle-reward-giver.vue"
export default component.exports